export enum UnitType {
  PIPS,
  PERCENT,
}

export namespace UnitType {
  let elements = [UnitType.PIPS, UnitType.PERCENT];
  let alias = "com.bcdfx.model.UnitType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
